import { EntityPropertyValueChangedDto } from '@services/http/clients/api-proxies';
import { CustomCellIconAndContentComponent } from '@shared/grids/custom-cell-icon-and-content/custom-cell-icon-and-content.component';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export type FormatValueFn = (value: any, type?: number) => any;

export function createActivityLogDetailsColumnDefs(
    formatValue: FormatValueFn
): ColDef<EntityPropertyValueChangedDto>[] {
    return [
        {
            colId: 'displayName',
            field: 'displayName',
            headerName: 'Field',
            sortable: false,
            filter: false,
            width: 200,
            wrapText: true,
            autoHeight: true,
            cellStyle: { fontWeight: '600' }
        },
        {
            colId: 'old',
            field: 'old',
            headerName: 'Previous Value',
            sortable: false,
            filter: false,
            flex: 1,
            minWidth: 180,
            wrapText: true,
            autoHeight: true,
            cellRenderer: CustomCellIconAndContentComponent,
            cellRendererParams: {
                getContent: (params: ICellRendererParams<EntityPropertyValueChangedDto>) => {
                    const data = params.data;
                    if (!data) return '';
                    return formatValue(data.old, data.type);
                }
            },
            cellStyle: { color: '#777777', whiteSpace: 'normal', wordBreak: 'break-word' }
        },
        {
            colId: 'new',
            field: 'new',
            headerName: 'Current Value',
            sortable: false,
            filter: false,
            flex: 1,
            minWidth: 180,
            wrapText: true,
            autoHeight: true,
            cellRenderer: CustomCellIconAndContentComponent,
            cellRendererParams: {
                iconName: 'arrowRight',
                getContent: (params: ICellRendererParams<EntityPropertyValueChangedDto>) => {
                    const data = params.data;
                    if (!data) return '';
                    return formatValue(data.new, data.type);
                }
            },
            cellStyle: { fontWeight: '600', whiteSpace: 'normal', wordBreak: 'break-word' }
        }
    ];
}
